import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import store from "./redux/store/store";
import "./components/Language/i18n";
import AwakiloLoader from "./components/AwakiloLoader";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <Suspense fallback={<AwakiloLoader fullScreen />}>
      <Provider store={store}>
        <App />
      </Provider>
    </Suspense>
  </Router>
);
